import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/faq/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/partials/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/header/course-header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/lesson-navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/modal/download-certificate/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/modal/log-out-confirmation/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/partials/modal/notify-me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/modal/training-slot/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/modal/verification-link-sent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/partials/provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/recommend-us/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/session-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/video-player/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/app/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogContent","DialogTitle"] */ "/app/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Drawer","DrawerContent"] */ "/app/components/ui/drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatProvider"] */ "/app/context/ChatContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
